import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  CardActionArea
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import GroupsIcon from '@mui/icons-material/Groups';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Nav from '../navcomun';

import fondoCancha from '../../../Assets/fondo-cancha.jpg'; // Asegúrate de que la ruta sea correcta

const iconSize = 60;

const items = [
  { label: 'Perfil', icon: <PersonIcon sx={{ fontSize: iconSize }} />, path: '/falta1/perfil', requiereLogin: true },
  { label: 'Partidos publicos', icon: <SportsSoccerIcon sx={{ fontSize: iconSize }} />, path: '/falta1/partidos' },
  { label: 'Buscar Jugadores', icon: <GroupsIcon sx={{ fontSize: iconSize }} />, path: '/falta1/jugadores' },
  { label: 'Solicitudes', icon: <MailOutlineIcon sx={{ fontSize: iconSize }} />, path: '/falta1/solicitudes', requiereLogin: true },
  { label: 'Crear Partido publico', icon: <AddCircleOutlineIcon sx={{ fontSize: iconSize }} />, path: '/falta1/crearpartidos', requiereLogin: true },
  { label: 'Preguntas Frecuentes', icon: <HelpOutlineIcon sx={{ fontSize: iconSize }} />, path: '/falta1/faq' },
];


const MenuPrincipal = () => {
  const navigate = useNavigate();
const loggedUserJSON = window.localStorage.getItem('loggedNoteAppUser');
const estaLogueado = !!loggedUserJSON;
  return (
    <>
      <Nav />
<div
  style={{
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    columnGap: 16,
      rowGapGap: 2,
  rowGap: 0, // Menor espacio entre filas
    padding: 16,
    backgroundImage: `url(${fondoCancha})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    minHeight: '100vh',
  }}
>

{items.map((item, index) => {
  const deshabilitada = item.requiereLogin && !estaLogueado;

  return (
    <Card
      key={index}
      sx={{
        height: 140,
        borderRadius: 3,
        boxShadow: 4,
        marginBottom: -10,
        backgroundColor: deshabilitada ? '#e0e0e0' : 'rgba(255,255,255,0.9)',
        opacity: deshabilitada ? 0.7 : 1,
        pointerEvents: deshabilitada ? 'none' : 'auto',
        '&:hover': {
          backgroundColor: deshabilitada ? '#e0e0e0' : '#d4edda',
        }
      }}
    >
      <CardActionArea
        onClick={() => navigate(item.path)}
        sx={{ height: '100%' }}
        disabled={deshabilitada}
      >
        <CardContent sx={{ textAlign: 'center', padding: '8px 8px' }}>
          <IconButton
            color="primary"
            disableRipple
            sx={{
              backgroundColor: deshabilitada ? '#cfd8dc' : '#e3f2fd',
              width: 70,
              height: 70,
              mb: 0.5,
              borderRadius: '50%',
              '&:hover': {
                backgroundColor: deshabilitada ? '#cfd8dc' : '#bbdefb'
              }
            }}
          >
            {item.icon}
          </IconButton>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            {item.label}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
})}

      </div>
    </>
  );
};

export default MenuPrincipal;
